// eslint-disable-next-line no-control-regex
const UNSAFE_FILE_NAME_CHARACTERS = /[\x00-\x1f"*/:<>?\\|]/g

/* Sanitizes potential file name, removing characters unsupported in file systems */
/* Identified example: dot in organization name, allowed in Shine, not allowed as a file name character */
export const sanitizeFileName = (value: string): string =>
  value
    .replace(UNSAFE_FILE_NAME_CHARACTERS, '-')
    .replace(/[.\s]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '')
